// getMessageUnlockPrice.js
'use strict';
import {
  FLIX_PRICE_VALUE,
  AUTO_MESSAGE_PRICE_VALUE,
} from '../RemoteConfigKeys.js';

import createCachedSelector from '../resource/createCachedSelector.js';

import getMessageData from '../selector/getMessageData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

/**
 * Select message unlock price by message id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} messageId - message id.
 * @return {number} The selected message unlock price.
 */
const getMessageUnlockPrice = createCachedSelector(
  (state, messageId) => getMessageData(state, messageId, 'isFlix'),
  (state, messageId) => getMessageData(state, messageId, 'isAutoMessage'),
  (state, messageId) => getMessageData(state, messageId, 'unlockPrice'),
  state => getRemoteConfigData(state, FLIX_PRICE_VALUE),
  state => getRemoteConfigData(state, AUTO_MESSAGE_PRICE_VALUE),
  (isFlix, isAutoMessage, defaultUnlockPrice, flixPrice, autoMessagePrice) => {
    if (isFlix && flixPrice != null) {
      return flixPrice;
    }
    if (isAutoMessage && autoMessagePrice != null) {
      return autoMessagePrice;
    }
    return defaultUnlockPrice;
  }
)((state, messageId) => `${messageId}`);

export default getMessageUnlockPrice;
